import {getWebhooks} from "./actions/getWebhooks";
import {getWebhook} from "./actions/getWebhook";
import {sendWebhook} from "./actions/sendWebhook";

export const actions = {
    getWebhooks,
    getWebhook,
    sendWebhook
};
